// A clock accompanies a calendar day; it must not be converted between timezones.
export function formatClockTime(value) {
  if (typeof value !== "string") return "";
  const match = value.match(/^([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d(?:\.\d+)?)?$/);
  if (!match) return "";
  const hour = Number(match[1]);
  return `${hour % 12 || 12}:${match[2]} ${hour >= 12 ? "pm" : "am"}`;
}
